import { css } from '@emotion/css';

import {
  AlignItems,
  BorderRadius,
  Font,
  TextAlign,
  Spacing,
  Display,
  Color,
  MOBILE_MIN_LINE_HEIGHT,
  ScreenBreakpoint,
} from '../../../styles';

export const alert = (type: 'success' | 'info' | 'warning' | 'error', condensed = false) => css`
  ${BorderRadius.xs}
  ${Spacing.p12}
  ${Spacing.m8}
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.35);
  border: none;
  ${Display.flex}
  align-items: flex-start !important;
  background-color: ${type === 'error'
    ? Color.Red1
    : type === 'warning'
    ? Color.Orange1
    : type === 'info'
    ? Color.Brand1
    : Color.Green1};

  .ant-alert-icon {
    align-self: flex-start;
    ${Spacing.mr8}
    /* Size the icon box to the description's first line (Font.lg) and center the glyph in it,
       so icons with uneven SVG padding still line up with the text. */
    ${Display.inlineFlex}
    ${AlignItems.center}
    height: 1.562rem;

    @media (max-width: ${ScreenBreakpoint.mobile.max}) {
      height: max(${MOBILE_MIN_LINE_HEIGHT}, 1.562rem);
    }
  }

  .ant-alert-description {
    ${TextAlign.left}
    ${Font.lg}
  }

  ${condensed &&
  css`
    ${Spacing.ml0}
    ${Spacing.p8}

    .ant-alert-description {
      white-space: pre;
    }
  `}
`;

export const icon = (type: 'success' | 'info' | 'warning' | 'error') => css`
  color: ${type === 'error'
    ? Color.Red7
    : type === 'warning'
    ? Color.Orange6
    : type === 'info'
    ? Color.Brand6
    : Color.Green6} !important;
`;
